import QueryString from 'brave-utils/query-string'


export function parseResponseHeaders(headerStr) {
  var headers = {}
  if (!headerStr) {
    return headers
  }
  var headerPairs = headerStr.split('\u000d\u000a')
  for (var i = 0, ilen = headerPairs.length; i < ilen; i++) {
    var headerPair = headerPairs[i]
    var index = headerPair.indexOf('\u003a\u0020')
    if (index > 0) {
      var key = headerPair.substring(0, index)
      var val = headerPair.substring(index + 2)
      headers[key] = val
    }
  }
  return headers
}

export function processCommonHeaders(headers) {
  if (headers['Content-Type']) {
    let [contentType, paramsPortion=false] = headers['Content-Type'].split(/ */)
    let contentParams = {}
    if (paramsPortion) {
      let qs = new QueryString(paramsPortion)
      contentParams = qs.toSingleValueDict()
    }
    let [type, subtype] = contentType.split('/')
    headers['Content-Type'] = {
      contentType: contentType,
      type: type,
      subtype: subtype,
      params: contentParams
    }
  }
  return headers

}

export function xhr(method, url, data, options={}) {
  options = Object.assign({withCredentials: true}, options)
  return new Promise((resolve, reject) => {
    let xhr = new global.XMLHttpRequest()
    xhr.withCredentials = options.withCredentials
    let body = false
    let contentType = options.contentType
    if (data) {
      if (contentType) {
        if (contentType === 'application/json') {
          if (options.prettyJSON) {
            body = JSON.stringify(data, null, '  ')
          } else {
            body = JSON.stringify(data)
          }
        } else {
          body = data
        }

      } else if (Array.isArray(data)) {
        let boundary = `brave-${Date.now().toString(16)}`
        contentType = `multipart/form-data boundary=${boundary}`
        let parts = []
        for (let [headers, blob] of data) {
          parts.push('\r\n--'+boundary+'\r\n')
          for(let headerName in headers) {
            parts.push(headerName + ': ' + headers[headerName] +'\r\n')
          }
          parts.push('\r\n')
          if (headers['Content-Type'] === 'application/json' && typeof blob !== 'string') {
            if (options.prettyJSON) {
              parts.push(JSON.stringify(blob, null, '  '))
            } else {
              parts.push(JSON.stringify(blob))
            }

          } else if (blob instanceof Blob) {
            parts.push(new Promise((resolve, reject) => {
              let reader = new FileReader()
              reader.onload = ((ev) => {
                resolve(ev.target.result)
              })
              reader.readAsArrayBuffer(blob)
            }))
          } else {
            parts.push(blob)
          }

        }
        parts.push('\r\n--'+boundary+'--\r\n')
        body = Promise.all(parts)
      } else {
        contentType = "application/x-www-form-urlencoded"
        let qs = new QueryString(data)
        if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS') {
          url = url + '?' + qs.toString()
        } else {
          body = qs.toString()
        }
      }
    }

    xhr.open(method, url)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    let responseType = options.responseType
    if (responseType) {
      xhr.responseType = responseType
    }


    if (body) {
      xhr.setRequestHeader("Content-Type", contentType)
      if (body instanceof Promise) {
        body.then(parts => xhr.send(new Blob(parts)))
      } else {
        xhr.send(body)
      }

    } else {
      xhr.send()
    }


    xhr.onerror = reject

    xhr.onload = (() => {
      let response = xhr.response
      if (typeof (response) === 'string' && responseType == 'json') {
        response = JSON.parse(response)
      }

      resolve({
        response: response,
        status: xhr.status,
        headers: processCommonHeaders(
          parseResponseHeaders(
            xhr.getAllResponseHeaders()))
      })
    })

  })

}

var jsonpCounter = 0
export function jsonp(callbackParam, url, data) {
  return new Promise((resolve, reject) => {
    jsonpCounter++
    let callbackName = "brave_jsonp_cb_" + jsonpCounter
    data[callbackParam] = callbackName
    let query = QueryString.makeQuery(data)
    if (query.length > 0) {
      if (/\?/.test(url)) {
        url = url + '&' + query.slice(1)
      } else {
        url = url + query
      }
    }
    let scriptEl = global.document.createElement('script')
    scriptEl.setAttribute('src', url)
    global.window[callbackName] = function(result) {
      resolve({text: result})
      delete global.window[callbackName]
      document.body.removeChild(scriptEl)
    }

    document.body.appendChild(scriptEl)
  })
}


// WEBPACK FOOTER //
// ./lib/brave-utils/xhr.js